@for (item of items; track item.id) {
  <div class="context-menu-item" [class.disabled]="item.disabled" (click)="onItemClick(item)">{{ item.label }}</div>
}
